<div class="modal-dialog-wrap">
  <button type="button" class="modal-dialog-close" (click)="closeModal()">
    <span class="material-symbols-outlined">close</span>
  </button>

  <h3 class="modal-dialog-title" *ngIf="menu?.title">{{ menu.title }}</h3>

  <div class="menu-grid">
    <div *ngFor="let it of menu?.menuitems" class="menu-item" (click)="openOrPlay(it)">
      <div class="menu-item__icon">
        <img [src]="it?.image ? it.image : '/assets/images/bt-link-generic.svg'">
      </div>
      <span class="menu-item__label">{{ it.cta_caption }}</span>
    </div>
  </div>
</div>